import React, { useEffect, useState } from 'react';
import { apiRequest } from '../../../../service/apiRequest';
import {
  Table,
  Button,
  Flex,
  Breadcrumb,
  Form,
  message,
  Popconfirm,
  Space,
  Pagination,
  Switch,
  TableProps,
} from 'antd';
import { createStyles } from 'antd-style';
import { HomeOutlined, DeleteOutlined, EditOutlined, PrinterOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import TailorInvoiceModal from './TailorInvoiceModal';
import { showSuccess, showError } from '../../../../components/errorHandler';
import type { PopconfirmProps, TableColumnsType } from 'antd';
import { useCurrentModule } from '../../../../hooks/useCurrentModule';
import { UnpaidList } from "../../../../types/UnpaidList";
const useStyle = createStyles(({ css }) => ({
  customTable: css`
    .ant-table {
      &-container {
        .ant-table-body,
        .ant-table-content {
          scrollbar-width: thin;
          scrollbar-color: #eaeaea transparent;
        }
      }
    }
  `,
}));


const Measurements: React.FC = () => {
  const [tailorinvoicedata, settailorinvoicedata] = useState<UnpaidList[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [initialValues, setInitialValues] = useState<UnpaidList | null>(null);
  const { styles } = useStyle();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const currentModule = useCurrentModule();

  const [filteredInfo, setFilteredInfo] = useState<Record<string, any>>({});
  const [sortedInfo, setSortedInfo] = useState<any>({});


  const cancel: PopconfirmProps['onCancel'] = (e) => {
    console.log(e);
    showError('Click on No');
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const fetchTailorInvoice = async () => {
    try {
      const data = await apiRequest<UnpaidList[]>({
        method: 'get',
        url: 'get-tailor-invoice',
      });
      settailorinvoicedata(data);
    } catch (error) {
      showError('Failed to fetch body shape ');
      console.error(error);
    }
  };



  useEffect(() => {
    fetchTailorInvoice();
  }, []);

  const handleEditClick = (record: UnpaidList) => {
    setIsEditMode(true);
    setInitialValues({
      ji_id: record.ji_id,
      ti_status: record.sd_status,
      sd_ledger_id: record.sd_ledger_id,
      ti_ledger_id: record.ti_ledger_id,
      sd_id: record.sd_id,
      sd_status: record.sd_status,
    });
    setIsModalVisible(true);
  };

  const handleCreate = () => {
    fetchTailorInvoice();
  };

  const showCreateModal = () => {
    setIsEditMode(false);
    setInitialValues(null);
    setIsModalVisible(true);
  };

  const hideCreateModal = () => {
    setIsModalVisible(false);
    setIsEditMode(false);
    setInitialValues(null);
  };

  const onPDFDownload = async (JiID: number, PDFType: string) => {
    try {
      const response = await apiRequest<Blob>({
        method: 'get',
        url: PDFType,
        data: {
          ji_id: [JiID],
        },
        config: {
          responseType: 'blob',
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${PDFType}_${JiID}.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error(`${PDFType} download error:`, error);
      message.error(`${PDFType} to download invoice.`);
    }
  };




  const handleTableChange: TableProps<UnpaidList>['onChange'] = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };


  const onTailorInvoiceDownload = async (ji_id: number) => {
    if (!ji_id) {
      message.error("Please select at least one job.");
      return;
    }

    try {
      const response = await apiRequest<Blob>({
        method: 'post',
        url: '/download-tailor-invoice',
        data: {
          ji_id,
        },
        config: {
          responseType: 'blob',  // ✅ fix here
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tailor_invoice.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error("tailor invoice download error:", error);
      message.error("Failed to download tailor invoice.");
    }
  };


  const onTailorReserveFundDownload = async (ji_id: number) => {
    try {
      const response = await apiRequest<Blob>({
        method: 'post',
        url: '/download-reserve-fund-voucher',
        data: {
          ji_id,
        },
        config: {
          responseType: 'blob',  // ✅ fix here
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tailor_reserve_fund_invoice.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error("tailor reserve fund invoice download error:", error);
      message.error("Failed to download tailor reserve fund invoice.");
    }
  };

  const onTailorTDSDownload = async (ji_id: number) => {
    try {
      const response = await apiRequest<Blob>({
        method: 'post',
        url: '/download-tds-voucher',
        data: {
          ji_id,
        },
        config: {
          responseType: 'blob',  // ✅ fix here
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tds_invoice.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error("tailor tds invoice download error:", error);
      message.error("Failed to download tailor tds invoice.");
    }
  };


  const columns: TableColumnsType<UnpaidList> = [
    {
      title: 'Ledger Name',
      dataIndex: 'ji_ledger_id',
      key: 'ji_ledger_id',
      width: 200,
      filters: Array.from(
        new Set(
          tailorinvoicedata.map(
            (s) => `${s.ledger_first_name} ${s.ledger_last_name}`
          )
        )
      ).map((name) => ({ text: name, value: name })),
      filterSearch: true,
      filterMode: 'tree',
      filteredValue: filteredInfo.ji_ledger_id || null,
      onFilter: (value, record) =>
        `${record.ledger_first_name} ${record.ledger_last_name}`.includes(
          value as string
        ),
      sorter: (a, b) =>
        `${a.ledger_first_name} ${a.ledger_last_name}`.localeCompare(
          `${b.ledger_first_name} ${b.ledger_last_name}`
        ),
      sortOrder: sortedInfo.columnKey === 'ji_ledger_id' ? sortedInfo.order : null,
      ellipsis: true,
      render: (_, record) =>
        `${record.ledger_first_name} ${record.ledger_last_name}`,
    },
    {
      title: 'Total Amount',
      dataIndex: 'ji_total_amount',
      key: 'ji_total_amount',
      render: (_, record) => `Rs. ${record.ji_total_amount}`,
    },
    {
      title: 'Payable Amount',
      dataIndex: 'ji_total_payble_amount',
      key: 'ji_total_payble_amount',
      render: (_, record) => `Rs. ${record.ji_total_payble_amount}`,
    },
    {
      title: 'TDS',
      dataIndex: 'ji_tds',
      key: 'ji_tds',
      render: (_, record) => `Rs. ${record.ji_tds}`,
    },
    {
      title: 'Reserve Fund',
      dataIndex: 'ji_reserve_fund',
      key: 'ji_reserve_fund',
      render: (_, record) => `Rs.${record.ji_reserve_fund}`,
    },
    {
      title: 'Created On',
      dataIndex: 'ji_created_on',
      key: 'ji_created_on',
      render: (_, record) =>
        record.ji_created_on
          ? new Date(record.ji_created_on).toLocaleString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          })
          : '-',
    },
  ];




  // Conditionally add action column
  if (currentModule?.right_edit === 'Y' || currentModule?.right_delete === 'Y') {
    columns.push({
      title: 'Action',
      width: 200,
      render: (_: any, record: UnpaidList) => (
        <Space size="middle">

          <Button
            type="primary"
            size="large"
            onClick={() => onTailorInvoiceDownload(record.ji_id)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height: 80,
              width: 100,
              padding: 0,
              margin: 0,
            }}
          >
            <PrinterOutlined style={{ fontSize: 24, marginBottom: 4 }} />

            <div
              style={{
                textAlign: 'center',
                fontSize: 14,
                lineHeight: 1.2,
                paddingTop: 0,
                paddingBottom: 0,
              }}
            >
              Tailor<br />Job
            </div>
          </Button>

          <Button
            type="primary"
            size="large"
            onClick={() => onTailorReserveFundDownload(record.ji_id)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height: 80,
              width: 100,
              padding: 0,
              margin: 0,
            }}
          >
            <PrinterOutlined style={{ fontSize: 24, marginBottom: 4 }} />

            <div
              style={{
                textAlign: 'center',
                fontSize: 14,
                lineHeight: 1.2,
                paddingTop: 0,
                paddingBottom: 0,
              }}
            >
              Reserve<br />Fund
            </div>
          </Button>
          <Button
            type="primary"
            size="large"
            onClick={() => onTailorTDSDownload(record.ji_id)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height: 80,
              width: 100,
              padding: 0,
              margin: 0,
            }}
          >
            <PrinterOutlined style={{ fontSize: 24, marginBottom: 4 }} />

            <div
              style={{
                textAlign: 'center',
                fontSize: 14,
                lineHeight: 1.2,
                paddingTop: 0,
                paddingBottom: 0,
              }}
            >
              TDS
            </div>
          </Button>
          {/* <Button
            icon={<PrinterOutlined style={{ fontSize: 24, margin: 4 }} />}
            onClick={() => onPDFDownload(record.ji_id, 'download-tailor-invoice')}
            type="primary"
            style={{ width: "100%", margin: 10 }}
          ></Button>
          <Button
            icon={<PrinterOutlined style={{ fontSize: 24, margin: 4 }} />}
            onClick={() => onPDFDownload(record.ji_id, 'download-tds-voucher')}
            type="primary"
            style={{ width: "100%", margin: 10 }}
          ></Button>
          <Button
            icon={<PrinterOutlined style={{ fontSize: 24, margin: 4 }} />}
            onClick={() => onPDFDownload(record.ji_id, 'download-reserve-fund-voucher')}
            type="primary"
            style={{ width: "100%", margin: 10 }}
          ></Button> */}

        </Space>
      ),
    });
  }


  return (
    <>
      <Space
        style={{
          display: 'flex',
          marginBottom: 16,
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Breadcrumb style={{ display: 'inline-block', margin: 0 }}>
          <Breadcrumb.Item href="/">
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>View Tailor Invoice </Breadcrumb.Item>
        </Breadcrumb>

        {currentModule?.right_add === 'Y' && (
          <Flex gap="small">
            <Button type="primary" onClick={showCreateModal}>
              Add Tailor Invoice
            </Button>
          </Flex>
        )}
      </Space>


      <div
        style={{
          minHeight: 360,
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
        }}
      >
        <Table<UnpaidList>
          tableLayout="auto"
          className={`${styles.customTable} scrollable-table`}
          columns={columns}
          onChange={handleTableChange}
          rowKey="ji_id"
          dataSource={tailorinvoicedata.slice(
            (pagination.current - 1) * pagination.pageSize,
            pagination.current * pagination.pageSize
          )}
          bordered
          pagination={false}
          scroll={{ y: 37 * 13 }}
          locale={{ emptyText: 'No Body Shape  found' }}
          footer={() => (
            <Flex justify="space-between">
              <span>
                Showing {(pagination.current - 1) * pagination.pageSize + 1}–
                {Math.min(pagination.current * pagination.pageSize, tailorinvoicedata.length)} of{' '}
                {tailorinvoicedata.length}
              </span>
              <Pagination
                {...pagination}
                total={tailorinvoicedata.length}
                showSizeChanger
                onChange={(page, pageSize) => setPagination({ current: page, pageSize })}
              />
            </Flex>
          )}
        />
      </div>

      <TailorInvoiceModal
        visible={isModalVisible}
        onCancel={hideCreateModal}
        onCreate={handleCreate}
        isEditMode={isEditMode}
        initialValues={initialValues}
        tailorinvoicedata={tailorinvoicedata}
      />
    </>
  );
};

export default Measurements;